import script from "./ContractGate.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContractGate.vue?vue&type=script&setup=true&lang=ts"

import "./ContractGate.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__